'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createTimestamp = exports.getTimestamp = exports.parseTimestamp = undefined;

var _base = require('base62');

var _base2 = _interopRequireDefault(_base);

var _uidConstants = require('./uidConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseTimestamp = exports.parseTimestamp = function parseTimestamp(timeStamp) {
    return _base2.default.decode(timeStamp) * _uidConstants.TIME_DIVISOR;
};

var getTimestamp = exports.getTimestamp = function getTimestamp(id) {
    return parseTimestamp(id.slice(0, _uidConstants.TIMESTAMP_LENGTH));
};

var createTimestamp = exports.createTimestamp = function createTimestamp(time) {
    var divisor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _uidConstants.TIME_DIVISOR;
    return _base2.default.encode(Math.floor(time / divisor));
};


//////////////////
// WEBPACK FOOTER
// ./src/common/uid/timestamp.js
// module id = 486
// module chunks = 0